import { t } from '../../../../common/components/T';

export const colors = ['var(--gold600Color)', 'var(--gold300Color)'];

export const blockSkeleton = () => {
    return [
        {
            row: [30, 50, 20],
            items: [
                {
                    content: [
                        {
                            type: 'title'
                        },
                        {
                            type: 'text',
                            width: 80
                        }
                    ]
                },
                'empty',
                {
                    type: 'circle',
                    diameter: 3,
                    align: 'right'
                }
            ],
            vertical: 'unset'
        },
        'empty',
        {
            row: [50, 50],
            items: [
                {
                    row: [50, 50],
                    items: ['blockLG', 'blockLG'],
                    gap: 2
                },
                'empty'
            ]
        },
        {
            type: 'chart'
        }
    ];
};

export const createWidgetData = (data, currency = {}, translation, periods) => {
    const period = {
        start: +data?.meta?.marketing_period_id_from,
        end: +data?.meta?.marketing_period_id_to,
        start_formatted: data?.meta?.marketing_period_from?.id_formatted,
        end_formatted: data?.meta?.marketing_period_to?.id_formatted
    };
    let leftBranchSum = 0;
    let rightBranchSum = 0;
    const periodsFiltered = periods?.slice(
        periods.findIndex((per) => +per.id === period.start),
        periods.findIndex((per) => +per.id === period.end) + 1
    );
    const categories = periodsFiltered.map((per) => per?.id_formatted);

    data?.data?.forEach((item) => {
        if (+item.position === 1) {
            leftBranchSum += Number(item?.volume);
        }
        if (+item.position === 2) {
            rightBranchSum += Number(item?.volume);
        }
    });

    const packagePrices = [50, 100, 200, 400, 600];

    return {
        ...data,
        period,
        currency,
        branches: {
            left: leftBranchSum,
            right: rightBranchSum
        },
        config: {
            allowChartUpdate: true,
            options: {
                chart: {
                    type: 'area',
                    className: 'dynamic-rewards'
                },
                legend: {
                    enabled: false
                },
                title: { text: null },
                xAxis: {
                    categories
                },
                yAxis: {
                    min: 0,
                    title: { text: null },
                    gridLineColor: '#CCC',
                    gridLineDashStyle: 'Dash'
                },
                height: 288,
                colors,
                plotOptions: {
                    series: {
                        marker: {
                            enabled: categories?.length === 1,
                            symbol: 'circle',
                            radius: 4,
                            states: {
                                hover: {
                                    enabled: true
                                }
                            }
                        },
                        lineWidth: 2,
                        fillColor: {
                            linearGradient: [0, 0, 0, 350],
                            stops: [
                                [0, 'var(--gold600Op2Color)'],
                                [1, 'transparent']
                            ]
                        }
                    },
                    area: {
                        states: {
                            hover: {
                                enabled: false // вимикає ефект фону при наведенні
                            }
                        }
                    }
                },
                series: [
                    {
                        name: t('left-branch', 'Левая ветка', '/office', translation),
                        data: categories.map((period) => {
                            return {
                                y: data?.data?.reduce((acc, it) => {
                                    if (it.marketing_period_id === period && +it?.position === 1) {
                                        acc += +it?.volume;
                                    }
                                    return acc;
                                }, 0),
                                ...packagePrices.reduce((accumulator, PV) => {
                                    accumulator[PV] =
                                        data?.data?.reduce((acc, it) => {
                                            if (it.marketing_period_id === period && +it?.position === 1) {
                                                acc += it?.details?.reduce((a, i) => {
                                                    if (+i?.name === PV) {
                                                        a += +i.count;
                                                    }
                                                    return a;
                                                }, 0);
                                            }
                                            return acc;
                                        }, 0) || '-';
                                    return accumulator;
                                }, {})
                            };
                        })
                    },
                    {
                        name: t('right-branch', 'Правая ветка', '/office', translation),
                        data: categories.map((period) => {
                            return {
                                y: data?.data?.reduce((acc, it) => {
                                    if (it.marketing_period_id === period && +it?.position === 2) {
                                        acc += +it?.volume;
                                    }
                                    return acc;
                                }, 0),
                                ...packagePrices.reduce((accumulator, PV) => {
                                    accumulator[PV] =
                                        data?.data?.reduce((acc, it) => {
                                            if (it.marketing_period_id === period && +it?.position === 2) {
                                                acc += it?.details?.reduce((a, i) => {
                                                    if (+i?.name === PV) {
                                                        a += +i.count;
                                                    }
                                                    return a;
                                                }, 0);
                                            }
                                            return acc;
                                        }, 0) || '-';
                                    return accumulator;
                                }, {})
                            };
                        })
                    }
                ],
                tooltip: {
                    crosshairs: true,
                    style: {
                        fontFamily: 'inherit'
                    },
                    shared: true,
                    borderRadius: 0,
                    borderWidth: 0,
                    shadow: false,
                    enabled: true,
                    backgroundColor: 'none',
                    useHTML: true,
                    headerFormat: `<div class="branch-dynamic-header"><span class="dynamic-rewards-header-label">${t(
                        'calculation_week',
                        'Расчетная неделя',
                        '/office',
                        translation
                    )}: <span class="dynamic-rewards-header-value">{point.key}</span></span></div><div class="branch-dynamic-table">`,
                    pointFormat: `<div class="branch-dynamic-item-wrap">
                        <div class="branch-dynamic-item">
                            <div class="dynamic-rewards-item-circle" style="background-color: {series.color}"></div>
                            <div class="dynamic-rewards-info">
                                <p class="dynamic-rewards-name">{series.name}</p>
                            </div>
                        </div>
                        <table class="branch-dynamic-item-info">
                            <tr>
                                <td>
                                    50 PV:
                                </td>
                                <td>
                                    {point.50}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    100 PV:
                                </td>
                                <td>
                                    {point.100}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    200 PV:
                                </td>
                                <td>
                                    {point.200}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    400 PV:
                                </td>
                                <td>
                                    {point.400}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    600 PV:
                                </td>
                                <td>
                                    {point.600}
                                </td>
                            </tr>
                        </table>
                    </div>`,
                    footerFormat: '</div>'
                }
            }
        }
    };
};
